import { joinOriginPath, runtimeConfig } from '@/config/runtime'

function normalizeCardId(cardId) {
  return encodeURIComponent(String(cardId || '').trim())
}

function buildCardAssetPath(cardId, filename) {
  return `${normalizeCardId(cardId)}/${filename}`
}

async function fetchStaticResource(url, responseType = 'json') {
  const response = await fetch(url, {
    cache: responseType === 'json' ? 'no-store' : 'default'
  })

  if (response.status === 404) {
    return null
  }

  if (!response.ok) {
    throw new Error(`Static resource request failed with status ${response.status}`)
  }

  return responseType === 'text' ? response.text() : response.json()
}

export function buildPublicCardUrl(cardId) {
  return joinOriginPath(runtimeConfig.cardOrigin, normalizeCardId(cardId))
}

export function isIOSDevice() {
  const platform = navigator.platform || ''
  const userAgent = navigator.userAgent || ''
  const isTouchMac = platform === 'MacIntel' && navigator.maxTouchPoints > 1
  return /iPad|iPhone|iPod/.test(userAgent) || isTouchMac
}

export function openExternalUrl(url) {
  if (isIOSDevice()) {
    window.location.href = `x-safari-${url}`
    return
  }

  window.location.assign(url)
}

export function openPublicCardUrl(cardId) {
  openExternalUrl(buildPublicCardUrl(cardId))
}

export function buildActivateUrl(cardId) {
  return joinOriginPath(runtimeConfig.appOrigin, `activate/${normalizeCardId(cardId)}`)
}

export function buildStaticCardAssetUrl(cardId, filename) {
  return joinOriginPath(runtimeConfig.staticCardsOrigin, buildCardAssetPath(cardId, filename))
}

export function getStaticCardAvatarUrl(cardId) {
  return buildStaticCardAssetUrl(cardId, 'avatar.png')
}

export function getStaticCardContactUrl(cardId) {
  return buildStaticCardAssetUrl(cardId, 'contact.vCard')
}

export async function fetchStaticCardData(cardId) {
  const data = await fetchStaticResource(buildStaticCardAssetUrl(cardId, 'data.json'))
  if (!data) {
    return null
  }

  const card = data.card || data
  return {
    ...card,
    customId: card.customId || String(cardId || '')
  }
}

export async function fetchStaticCardContact(cardId) {
  return fetchStaticResource(getStaticCardContactUrl(cardId), 'text')
}
